import { useForm, Head, Link } from '@inertiajs/react';
import FormErrors from '../../components/FormErrors';
import FlashMessages from '../../components/FlashMessages';

export default function Login({ errors }) {
  const { data, setData, post, processing } = useForm({
    session: {
      email_address: '',
      password: '',
      remember_me: false,
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    post('/login');
  };

  return (
    <>
      <Head title='Login' />
      <section
        className='flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8'
        style={{ height: 'calc(100vh - 115px)' }}
      >
        <div className='max-w-md w-full space-y-8'>
          <div>
            <FlashMessages />
            <FormErrors errors={errors} />
            <h2 className='mt-6 text-center text-3xl font-extrabold text-gray-900'>
              Sign in to your account
            </h2>
          </div>

          <form className='mt-8 space-y-6' onSubmit={handleSubmit}>
            <div className='rounded-md shadow-sm -space-y-px'>
              <div>
                <label htmlFor='email-address' className='sr-only'>
                  Email address
                </label>
                <input
                  id='email-address'
                  name='email_address'
                  type='email'
                  autoComplete='email'
                  required
                  className='appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-[var(--color-yellow-primary)] focus:border-[var(--color-yellow-primary)] focus:z-10 sm:text-sm'
                  placeholder='Email address'
                  value={data.email_address}
                  onChange={(e) =>
                    setData('session.email_address', e.target.value)
                  }
                />
              </div>
              <div>
                <label htmlFor='password' className='sr-only'>
                  Password
                </label>
                <input
                  id='password'
                  name='password'
                  type='password'
                  autoComplete='current-password'
                  required
                  className='appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-[var(--color-yellow-primary)] focus:border-[var(--color-yellow-primary)] focus:z-10 sm:text-sm'
                  placeholder='Password'
                  value={data.password}
                  onChange={(e) => setData('session.password', e.target.value)}
                />
              </div>
            </div>

            {errors.email_address && (
              <div className='text-red-500 text-sm'>{errors.email_address}</div>
            )}
            {errors.password && (
              <div className='text-red-500 text-sm'>{errors.password}</div>
            )}

            <div className='flex items-center justify-between'>
              <div className='flex items-center'>
                <input
                  id='remember-me'
                  name='remember_me'
                  type='checkbox'
                  className='h-4 w-4 text-indigo-600 focus:ring-[var(--color-yellow-primary)] border-gray-300 rounded'
                  checked={data.remember_me}
                  onChange={(e) =>
                    setData('session.remember_me', e.target.checked)
                  }
                />
                <label
                  htmlFor='remember-me'
                  className='ml-2 block text-sm text-gray-900'
                >
                  Remember me
                </label>
              </div>

              <div className='text-sm'>
                <Link
                  href='/forgot_password'
                  className='font-medium text-indigo-600 hover:text-indigo-500'
                >
                  Forgot your password?
                </Link>
              </div>
            </div>

            <div className='flex justify-center items-center gap-3'>
              <button
                type='submit'
                className='group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[var(--color-yellow-primary)] hover:bg-[var(--color-yellow-secondary)] hover:text-slate-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--color-yellow-primary)]'
                disabled={processing}
              >
                Sign in
              </button>
              <Link
                href='/products'
                className='bg-slate-900 w-full text-center hover:border-[var(--color-yellow-secondary)] rounded-md text-[var(--color-yellow-secondary)] font-body py-2 px-3 shadow-lg transition duration-300 ease-in-out transform hover:-translate-y-0.5 hover:border '
              >
                Back
              </Link>
            </div>
          </form>
        </div>
      </section>
    </>
  );
}
